import { ReactNode } from "react";
import { motion } from "framer-motion";
import { DUR, EASE } from "../../lib/motion";
import "./MaskLine.css";

interface MaskLineProps {
    children: ReactNode;
    delay?: number;
    className?: string;
}

/**
 * One line of display type, rising from behind its own baseline.
 *
 * The mask — `overflow: hidden` on the outer span — is what makes this read as
 * typography arriving rather than an element fading in. Nothing is ever seen
 * at partial opacity; it simply is not there, and then it is.
 *
 * Shared by Home's hero and Intro's splash screen — both put the same name on
 * screen with the same reveal, and that repetition is deliberate (the splash
 * teases the exact motion the hero pays off), so it has to be pixel-identical
 * rather than two components that happen to look similar today and drift
 * apart the next time one of them gets tuned.
 */
export default function MaskLine({ children, delay = 0, className }: MaskLineProps) {
    return (
        <span className={`mask-line ${className ?? ""}`}>
            <motion.span
                className="mask-line-inner"
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: DUR.slow, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}
